"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const creditcarddefault = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 194 121",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-creditcarddefault` : '') + (description ? ` desc-creditcarddefault` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-creditcarddefault"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-creditcarddefault"
  }, description), /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#ccc",
    width: "194",
    height: "121",
    rx: "5",
    ry: "5"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#999a9d",
    y: "19.47",
    width: "194",
    height: "25.32"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#999a9d",
    x: "20",
    y: "76.46",
    width: "114",
    height: "18.32"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    fill: "#fff",
    x: "149.99",
    y: "76.46",
    width: "24.01",
    height: "18.32"
  }))));
};
var _default = exports.default = creditcarddefault;